module.exports = __webpack_public_path__ + "img/cns_printer_pc3.81877746.png";